<template>
    <div data-app>
        <v-dialog v-model="dialog" persistent max-width="350">
            <v-card>
                <v-card-title class="headline">
                    Emin misiniz?
                </v-card-title>
                <v-card-text
                    >Silmek istediğiniz kayıt kalıcı olarak silinecektir. Bu
                    kaydı silmek istediğinize emin misiniz?</v-card-text
                >
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="text-danger" text @click="dialog = false">
                        Hayır
                    </v-btn>
                    <v-btn class="text-success" text @click="deleteTransaction">
                        Evet
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <div class="col-md-12">   
            <KTCard v-bind:title="page_title">
                <template v-slot:body>
                    <form ref="form" id="form" novalidate="novalidate" lazy-validation class="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed">
                        <div class="m-portlet__body">
                            <div class="form-group m-form__group row">
                                <label class="col-lg-3 col-form-label">Üye:</label>
                                <div class="col-lg-9">
                                    <select class="form-control" v-model="transaction.user_id" :class="{view: !isEditing}" :disabled="!isEditing">
                                        <option v-for="user in users" :value="user.id" :key="user.id">{{ user.name }} </option>
                                    </select>
                                    <div v-if="errors.user_id" :errors="errors">
                                        <b-badge v-for="error in errors.user_id" class="mr-1" :key="error.user_id" variant="danger">{{ error }}</b-badge>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group m-form__group row">
                                <label class="col-lg-3 col-form-label">Tarih</label>
                                <div class="col-lg-9">
                                    <input type="date" class="form-control form-control-sm m-input" :class="{view: !isEditing}" :disabled="!isEditing" v-model="transaction.transaction_date">
                                    <div v-if="errors.transaction_date" :errors="errors">
                                        <b-badge v-for="error in errors.transaction_date" class="mr-1" :key="error.transaction_date" variant="danger">{{ error }}</b-badge>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group m-form__group row">
                                <label class="col-lg-3 col-form-label">İşlem Türü:</label>
                                <div class="col-lg-9">
                                    <select class="form-control" v-model="transaction.type" :class="{view: !isEditing}" :disabled="!isEditing">
                                        <option v-for="transaction_type in transaction_types" :value="transaction_type" :key="transaction_type">{{ transaction_type }}</option>
                                    </select>
                                    <div v-if="errors.transaction_type" :errors="errors">
                                        <b-badge v-for="error in errors.transaction_type" class="mr-1" :key="error.transaction_type" variant="danger">{{ error }}</b-badge>
                                    </div>
                                </div>
                            </div>

                            

                            <div class="form-group m-form__group row">
                                <label class="col-lg-3 col-form-label">Tutar:</label>
                                <div class="col-lg-9">
                                    <input type="number" class="form-control form-control-sm m-input" :class="{view: !isEditing}" :disabled="!isEditing" v-model="transaction.amount">
                                    <div v-if="errors.amount" :errors="errors">
                                        <b-badge v-for="error in errors.amount" class="mr-1" :key="error.amount" variant="danger">{{ error }}</b-badge>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group m-form__group row">
                                <label class="col-lg-3 col-form-label">Ödeme Şekli:</label>
                                <div class="col-lg-9">
                                    <select class="form-control" v-model="transaction.payment_type" :class="{view: !isEditing}" :disabled="!isEditing">
                                        <option v-for="payment_type in payment_types" :value="payment_type" :key="payment_type">{{ payment_type }}</option>
                                    </select>
                                    <div v-if="errors.payment_type" :errors="errors">
                                        <b-badge v-for="error in errors.payment_type" class="mr-1" :key="error.payment_type" variant="danger">{{ error }}</b-badge>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group m-form__group row">
                                <label class="col-lg-3 col-form-label">Makbuz No:</label>
                                <div class="col-lg-9">
                                    <input type="text" class="form-control form-control-sm m-input" :class="{view: !isEditing}" :disabled="!isEditing" v-model="transaction.receipt_no">
                                    <div v-if="errors.receipt_no" :errors="errors">
                                        <b-badge v-for="error in errors.receipt_no" class="mr-1" :key="error.receipt_no" variant="danger">{{ error }}</b-badge>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group m-form__group row">
                                <label class="col-lg-3 col-form-label">Açıklama:</label>
                                <div class="col-lg-9">
                                    <textarea class="form-control form-control-sm m-input" :class="{view: !isEditing}" :disabled="!isEditing" v-model="transaction.description"></textarea>
                                    <div v-if="errors.description" :errors="errors">
                                        <b-badge v-for="error in errors.description" class="mr-1" :key="error.description" variant="danger">{{ error }}</b-badge>
                                    </div>
                                </div>
                            </div>

                            <template v-if="timeStamps">
                                <div class="form-group m-form__group row">
                                    <label class="col-lg-3 col-form-label">Ekleyen:</label>
                                    <div class="col-lg-9">
                                        {{ transaction.user_created_name }}
                                    </div>
                                </div>
                                
                                <div class="form-group m-form__group row">
                                    <label class="col-lg-3 col-form-label">Ekleme Tarihi:</label>
                                    <div class="col-lg-9">
                                        <span>{{ transaction.created_at | formatDateTime }}</span>
                                    </div>
                                </div>

                                <div class="form-group m-form__group row">
                                    <label class="col-lg-3 col-form-label">Güncelleyen:</label>
                                    <div class="col-lg-9">
                                        {{ transaction.user_updated_name }}
                                    </div>
                                </div>

                                <div class="form-group m-form__group row">
                                    <label class="col-lg-3 col-form-label">Güncelleme Tarihi:</label>
                                    <div class="col-lg-9">
                                        <span>{{ transaction.updated_at | formatDateTime }}</span>
                                    </div>
                                </div>

                        </template>
                          
                        </div>
                        <div class="m-portlet__foot m-portlet__no-border m-portlet__foot--fit">
                            <div class="m-form__actions m-form__actions--solid">
                                <div class="row">
                                    <div class="col-lg-3"></div>
                                    <div class="col-lg-9">
                                        <!-- EKLEME BUTONLARI -->
                                        <template v-if="addButtons">
                                            <b-button
                                                v-if="hasPermission('transactions.create')"
                                                size="sm"
                                                variant="success"
                                                :disabled="isDisabled"
                                                @click="saveTransactionAndGoBack()"
                                            >
                                            <i class="la la-save"></i>
                                            <i class="la la-rotate-left"></i>
                                                Kaydet ve Geri Dön
                                            </b-button>
                                            
                                            <b-button
                                                v-if="hasPermission('transactions.create')"
                                                size="sm"
                                                variant="primary"
                                                :disabled="isDisabled"
                                                @click="saveTransactionAndAddNew()"
                                            >
                                            <i class="la la-save"></i>
                                                Kaydet ve Yeni Ekle
                                            </b-button>
                                        </template>

                                        <!-- GÜNCELLEME BUTONLARI -->
                                        <template v-if="editButtons">  
                                            <b-button
                                                v-if="hasPermission('transactions.update')"
                                                size="sm"
                                                variant="success"
                                                :disabled="isDisabled"
                                                @click="updateTransactionAndGoBack()"
                                            >
                                            <i class="la la-save"></i>
                                            <i class="la la-rotate-left"></i>
                                                Güncelle ve Geri Dön
                                            </b-button>

                                            <b-button
                                                v-if="hasPermission('transactions.update')"
                                                size="sm"
                                                variant="primary"
                                                :disabled="isDisabled"
                                                @click="updateTransaction()"
                                            >
                                            <i class="la la-save"></i>
                                                Güncelle
                                            </b-button>

                                            <b-button
                                                v-if="hasPermission('transactions.delete')"
                                                size="sm"
                                                variant="danger"
                                                :disabled="isDisabled"
                                                @click="dialog = true"
                                            >
                                            <i class="la la-trash"></i>
                                                Sil
                                            </b-button>

                                            
                                            
                                        </template>

                                        <!-- GÖRÜNTÜLEME BUTONLARI -->
                                        <template v-if="viewButtons">
                                            <b-button
                                                v-if="hasPermission('transactions.delete')"
                                                size="sm"
                                                variant="danger"
                                                :disabled="isDisabled"
                                                @click="dialog = true"
                                            >
                                            <i class="la la-trash"></i>
                                                Sil
                                            </b-button>

                                            <b-button
                                                v-if="hasPermission('transactions.update')"
                                                size="sm"
                                                variant="success"
                                                :disabled="isDisabled"
                                                @click="changeFormToEditing()"
                                            >
                                            <i class="la la-edit"></i>
                                                Güncellemeyi Aktif Et
                                            </b-button>
 
                                        </template>   
                                        <template>
                                            <b-button 
                                                size="sm" 
                                                @click="$router.go(-1)">
                                                <i class="la la-undo"></i>
                                                İptal
                                            </b-button> 
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </template>
            </KTCard>
        </div>
        <div class="text-center">
            <b-spinner
                variant="primary"
                type="grow"
                label="Spinning"
                v-if="loading"
            ></b-spinner>
        </div>
    
    </div>



    
</template>

<script>

import KTCard from "@/view/content/Card.vue";
import { mapGetters} from 'vuex';
import { mapState} from 'vuex';
import { GET_TRANSACTION_DATA } from "@/core/services/store/transactions.module";
import { CREATE_TRANSACTION } from "@/core/services/store/transactions.module";
import { UPDATE_TRANSACTION } from "@/core/services/store/transactions.module";
import { DELETE_TRANSACTION } from "@/core/services/store/transactions.module";
import { ALL_USERS } from "@/core/services/store/users.module";
import { ALL_PERIODS } from "@/core/services/store/periods.module";
import constants from '@/core/constants/index';

//import Echo from 'laravel-echo';

export default {
    name: "transactions-form",
    
    data() {
        return {
            dialog: false,
            transaction:{
                achievements: [],
                user_created_name: "",
                user_updated_name: ""
            },
            formType: "",
            page_title: "",
            addButtons: false,
            editButtons: false,
            viewButtons: false,
            timeStamps: false,
            isEditing: true,
            transactions: {},
            users: {},
            periods: {},
            options: [
                { value: '1', text: 'Evet', selected: true },
                { value: '0', text: 'Hayır' },
            ],

            value: [],
            transaction_types: constants.TRANSACTION_TYPES,
            payment_types: constants.PAYMENT_TYPES
                        
        };
    },
   
    methods: {
        saveTransactionAndGoBack() {
            const data = this.transaction;
            const goBack = true;
            this.$store.dispatch(CREATE_TRANSACTION, {data, goBack})
        },

        saveTransactionAndAddNew() {
            const data =  this.transaction;
            const goBack = false;
            this.$store.dispatch(CREATE_TRANSACTION, {data, goBack})
        },

        updateTransactionAndGoBack() {
            const data = this.transaction;
            const goBack = true;
            this.$store.dispatch(UPDATE_TRANSACTION, { data, goBack })
        },

        updateTransaction() {
            const data = this.transaction;
            const goBack = false;
            this.$store.dispatch(UPDATE_TRANSACTION, { data, goBack })
        },

        deleteTransaction() {
            var itemToDelete = this.transaction.id;
            this.$store.dispatch(DELETE_TRANSACTION, { itemToDelete })
            .then(() => { 
                this.$router.go(-1);
                this.dialog = false;
            })
        },

        changeFormToAdding(){
            this.page_title = "Üye İşlemleri: Yeni Kayıt Formu"
            
            this.addButtons = true;
            this.editButtons = false;
            this.viewButtons = false;
            this.timeStamps = false;
            this.isEditing = true;
        },

        changeFormToEditing(){
            this.page_title = "Üye İşlemleri: Güncelleme Formu"
            this.addButtons = false;
            this.editButtons = true;
            this.viewButtons = false;
            this.timeStamps = true;
            this.isEditing = true;
        },

        changeFormToViewing(){
            this.page_title = "Üye İşlemleri: Detaylar"
            this.addButtons = false;
            this.editButtons = false;
            this.viewButtons = true;
            this.timeStamps = true;
            this.isEditing = false;
        },

        hasPermission(permission) {
            return this.currentUserMenu.permissions.some(function(el) {
                return el.name === permission;
            }); 
        },


    },


    components: {
        KTCard,
        //Multiselect
    },

    created() {
        this.isEditing = !this.isEditing;
        this.formType = this.$route.params.formType;
        this.$store.dispatch('getUserMenu');
        this.$store.dispatch('createTransactionForm');

        this.$store.dispatch(ALL_USERS)
        .then(( response ) => {
            this.users = response.data;
        })

        this.$store.dispatch(ALL_PERIODS)
        .then(( response ) => {
            this.periods = response.data;
        })

        this.transaction.is_active = 1;
        if (this.formType != "add") {
            var id = this.$route.params.id;
            this.$store.dispatch(GET_TRANSACTION_DATA, { id })
            .then(( response ) => {
                this.transaction = response.data;
                this.transaction.user_created_name = response.data.user_created_name[0].name;
                this.transaction.user_updated_name = response.data.user_updated_name[0].name;
            })
        }
    },

    mounted() {
        
        if(this.formType === "add"){
            this.changeFormToAdding();
        }
        if(this.formType === "edit"){
            this.changeFormToEditing();
        }
        if(this.formType === "view"){
            this.changeFormToViewing();
        }
    },

    computed: {
        ...mapGetters(["currentUserMenu"]),

        ...mapState({
            loading: state => state.transactions.loading,
            row: state => state.transactions.row,
            errors: state => state.transactions.errors,
            isDisabled: state => state.transactions.isDisabled,
            //user: state => state.users.user_data
        })
    }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.view {
    border-color: transparent;
    background-color: initial;
    color: initial
}
</style>
